export const FETCH_CLINICS_REQUEST = "FETCH_CLINICS_REQUEST";
export const CREATE_CLINIC_REQUEST = "CREATE_CLINIC_REQUEST";
